module.exports = __webpack_public_path__ + "img/conzuo.70148bdb.png";